// Navigation getters
export default {
  get_navigation: (state) => state,
};
